import { defineComponent as _defineComponent } from 'vue';
import { useSegment } from '~/composables/_next/useSegment';
import { cacheControlNoStore } from '~/helpers/cacheControl';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import useHtmlMeta from '~/composables/useHtmlMeta';
import Toaster from '~/components/Layout/Toaster.vue';
const __nuxt_page_meta = {
  middleware: [cacheControlNoStore],tracking: {
        category: TrackingPageCategory.ERROR
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: 'error',
  props: {
    error: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var _useHtmlMeta = useHtmlMeta(),
      setHtmlLocale = _useHtmlMeta.setHtmlLocale;
    ;
    setHtmlLocale();
    useHead({
      title: props.error.statusCode === '404' ? i18n.t('errorPage.pageNotFoundHeaderTitle') : i18n.t('errorPage.anErrorOccurredTitle')
    });
    onMounted(function () {
      var _useSegment = useSegment(),
        analytics = _useSegment.analytics;
      var route = useRoute();
      analytics.page(TrackingPageCategory.ERROR, PageTypes.ERROR, {
        path: route.fullPath,
        type: props.error.statusCode === '404' ? 'not-found' : 'error'
      });
    });
    return {
      __sfc: true,
      props: props,
      i18n: i18n,
      setHtmlLocale: setHtmlLocale,
      AzButton: AzButton,
      Toaster: Toaster
    };
  }
});